import CONSTANTES from "../constantes";

export const actionGetClientes = (filter) => ({
    type: CONSTANTES.GET_CLIENTES,
    filter
})
export const actionPutClientes = clientes => ({
    type: CONSTANTES.PUT_CLIENTES,
    clientes,
})
export const actionGetCliente=(idCliente)=>({
    type:CONSTANTES.GET_DETAIL_CLIENTE,
    idCliente
})

export const actionPutDetailCliente=(cliente)=>({
    type:CONSTANTES.PUT_DETAIL_CLIENTE,
    cliente
})

export const actionRegistrarCliente = values => ({
    type: CONSTANTES.REGISTRO_CLIENTE,
    values,
})

export const actionAddCliente = cliente => ({
    type: CONSTANTES.ADD_CLIENTE,
    cliente,
})
export const actionEditarCliente=(idCliente,values)=>({
    type:CONSTANTES.EDITAR_CLIENTE,
    values,
    idCliente
})
export const actionPutCliente = cliente => ({
    type: CONSTANTES.PUT_CLIENTE,
    cliente,
})

